import find from 'lodash/find'

export interface IconType {
  expr: RegExp
  color: string
  type: 'text' | 'table' | 'image' | 'code' | 'slides'
}

const _fileTypes = [
  {
    expr: /(xlsx?|numbers)/i,
    color: '#70c79a',
    type: 'table',
  },
  {
    expr: /(png|jpe?g|tiff|gif)/i,
    color: '#40a0f4',
    type: 'image',
  },
  {
    expr: /(js|cs|java|md|c|py|ts)/i,
    color: '#999',
    type: 'code',
  },
  {
    expr: /(pptx?|key)/i,
    color: '#FF5252',
    type: 'slides',
  },
  {
    expr: /.*/,
    color: '#FF5252',
    type: 'text',
  },
]

export const IconType = (fileType = '') =>
  (find(_fileTypes, (opts) => fileType.match(opts.expr)) as IconType) ||
  _fileTypes[_fileTypes.length - 1]
